export const OUTCOME_PROVIDER_BLACK_LIST = ['pragmaticplay', 'habanero', 'pgsoft', 'platipus', 'upgaming']
